import Cookies from "js-cookie";

export const AUTH_CHANGED_EVENT =
    "mexfba-auth-changed";

const cookieOptions = {
    sameSite: "lax" as const,
    path: "/"
};

function notifyAuthenticationChanged(): void {
    window.dispatchEvent(
        new Event(AUTH_CHANGED_EVENT)
    );
}

export function getAuthenticatedUsername(): string | null {
    return (
        Cookies.get("access_username") ||
        Cookies.get("access_user") ||
        null
    );
}

export function isAuthenticated(): boolean {
    return Boolean(
        Cookies.get("access_token") &&
        Cookies.get("access_username")
    );
}

export function setAuthentication(
    userId: string,
    userName: string,
    username: string,
    expiresAt: Date
): void {
    Cookies.set("access_token", userId, {
        ...cookieOptions,
        expires: expiresAt
    });

    Cookies.set("access_user", userName, {
        ...cookieOptions,
        expires: expiresAt
    });

    Cookies.set("access_username", username, {
        ...cookieOptions,
        expires: expiresAt
    });

    Cookies.set("refresh_token", userId, {
        ...cookieOptions,
        expires: expiresAt
    });

    /*
        Notifica a Tabs, Login y cualquier pantalla que
        escuche cambios de autenticación.
    */
    notifyAuthenticationChanged();
}

export function clearAuthentication(): void {
    /*
        Debe coincidir con path: "/" usado al guardar las cookies.
        Si no coincide, js-cookie no puede eliminarlas correctamente.
    */
    Cookies.remove("access_token", cookieOptions);

    Cookies.remove("access_user", cookieOptions);

    Cookies.remove(
        "access_username",
        cookieOptions
    );

    Cookies.remove("refresh_token", cookieOptions);

    notifyAuthenticationChanged();
}
